import React, { Fragment } from "react"
import { Button, Modal } from "react-bootstrap"

const ModalAnzyz = ({ show, setShow, handleClose, cancelBtn, continueBtn, cancelTxt, continueTxt, title, body }) => {
	return (
		<Fragment>
			<Modal show={show} onHide={handleClose}>
				<Modal.Header>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{body}</Modal.Body>
				<Modal.Footer>
					<Button
						data-cy="continue"
						variant="secondary"
						id="btn_modal_continuar"
						onClick={(e) => {
							continueBtn(e)
						}}
					>
						{continueTxt}
					</Button>
					<Button
						variant="primary"
						id="btn_modal_cancelar"
						onClick={(e) => {
							cancelBtn(e)
						}}
					>
						{cancelTxt}
					</Button>
				</Modal.Footer>
			</Modal>
		</Fragment>
	)
}

export default ModalAnzyz
